<template>
  <a-list size="large" :pagination="false" >
    <a-list-item
      :key="index"
      v-for="(item, index) in waitingPackageData"
      class="waiting_package_data_row"
      :class="{ is_scanned: item.is_scanned }"
      style="padding-left: 20px; padding-right:20px">
      <div class="list-content">
        <div class="list-content-item product-info">
          <div>
            <a-image
              width="75px"
              size="large"
              shape="square"
              :src="item.img"
              fallback="data:image/png;base64,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"
            />
          </div>
          <div class="product-info-detail">
            <span><b>{{ item.RmaID }}</b></span><br/>
            <span>{{ item.product_sku }}</span><br/>
            <span>{{ item.product_size }}</span><br/>
            <!-- <span>{{ item.is_scanned }}</span> -->
          </div>
          <div class="product-info-detail">
            <span><b>{{ formatDateWithTime(item.CreatedAt) }}</b></span><br/>
            {{ $t("route.By") }} {{ item.created_by }}
          </div>
          <!--
          <div class="product-info-detail resaon">
            <span><b>Reasons</b></span>
            <ul style="list-style-type:none;">
              <li v-for="reason in item.rma_item_to_reason" :key="reason.ID">{{ reason.Name }}</li>
            </ul>
          </div>
          -->
        </div>
      </div>
      <template #actions>
        <!-- <SearchOutlined @click="setSelectedItem(item)"/> -->
        <a-button v-if="item.is_scanned" type="primary">{{ $t("route.scanned") }} </a-button>
        <a-button v-else danger>{{ $t("route.unscanned") }} </a-button>
        <!-- @click="handleRePrintLabel(item.id)" -->
      </template>
    </a-list-item>
  </a-list>
</template>
<script>
  import { ref } from 'vue'
  // import PreparePackageState from '../state/PreparePackage.js'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { formatDateWithTime } from '@/utils/utils'
  import { useI18n } from 'vue-i18n';
  import useRmaRepositories from "@/composables/useRmaRepositories"

  export default {
    name: 'ProductList',
    // props: ['waitingPackageData', 'state'],
    props: {
      waitingPackageData: {
        type: Array,
        default: null
      },
      state: {
        type: Function,
        default: null
      }
    },
    components: {
      SearchOutlined
    },
    setup(props) {
      // const { setSelectedItem } = PreparePackageState()
      const { setSelectedItem } = props.state()
      const { t ,locale } = useI18n({ useScope: 'global' })
      const { printItemLabel } = useRmaRepositories()

      const returnUtcDateWithFormat = (date) => {
        var dateData = new Date(date)
        return dateData.getFullYear() + "-" + parseInt(dateData.getMonth()+1) + "-" + dateData.getDate()
      }

      const handleRePrintLabel = async (reprintID) =>{
        const result = await printItemLabel([reprintID])
        return window.open(result.data.url)
      }

      return {
        setSelectedItem,
        returnUtcDateWithFormat,
        handleRePrintLabel,
        formatDateWithTime,
        t, locale
      }
    }
  }
</script>
<style lang="scss" scoped>
.waiting_package_data_row{
  border: 0;
  border-right: 8px solid;
  border-left: 8px solid;
  box-sizing: border-box;
  border-color: #ff5959;
  background-color: #ffdada;
  border-top: 1px solid #f0f0f0;
  padding-top:0;
  padding-bottom:0;
}

.waiting_package_data_row.is_scanned{
    border-color: #86D067;
    border-top: 1px solid #f0f0f0;
    background-color: #efffe8;
}
.home::v-deep {
  padding-left: 10px;
  padding-right: 10px;
}

.ant-card .ant-card-body::v-deep {
  padding: 10px!important;
}

.ant-image::v-deep {
  float: right!important;
}

.wrapper2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge2 {
  display: inline-block;
  border-radius: 50%;
  font-size: 20px;
  padding: 10px;
  min-width: 55px;
  text-align: center;
  background: #86D067;
  color: #fefefe;
}

.badge3 {
  display: inline-block;
  border-radius: 50%;
  font-size: 20px;
  padding: 10px;
  min-width: 55px;
  text-align: center;
  background: #FF4D4E;
  color: #fefefe;
}

button:disabled::v-deep,
button[disabled]::v-deep{
  border: 1px solid #999999!important;
  background-color: #cccccc!important;
  color: #666666!important;
}

.loading{
  left:46%;
  top:50%;
  position: absolute;
}

.product-info{
  display: flex;
}

.product-info-detail{
  padding-left: 20px;
  &.resaon{
    padding-left: 8vw;
  }
}

.ant-list-item-action{

}
</style>